// extracted by mini-css-extract-plugin
module.exports = {"saveTag":"deposit-contribution_saveTag__PK7rn","text":"deposit-contribution_text__9Gwtn"};